
export default function formatNumber(n: number | null) {
    return n?.toLocaleString("sv-SE", { minimumFractionDigits: 0, maximumFractionDigits:14 });
}